import styled from 'styled-components'

export const ProtectedLayoutWrapper = styled.div`
  
`
export const ToggleCollapse = styled.span`
  font-size: 20px;
  color: #9f9898;
  padding: 0 24px;
  cursor: pointer;
`
export const HeaderDivider = styled.div`
  width: 1px;
  background: rgb(237 237 237);
  height: 51%;
  margin: 0 24px;
`
export const ToggleTheme = styled.span`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
`
export const ChangeLanguage = styled.div`
  padding-bottom: 3px;
  padding-left: 16px;
`
export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
`
export const HeaderRight = styled.div`
`
